import React, { useEffect } from "react";
import { ADMIN_BELL_ICON, ADMIN_LOGO, ADMIN_MSG_ICON, HEADER_DOWN_ARROW, PMBI_ADMIN_LOGO } from "../../../../utils/app-image-contant";
import { Link, useNavigate } from "react-router-dom";
import { clearAdminAccessTokenReducer } from "../../../../hooks/redux/slice/admin-access-token";
import { useDispatch } from "react-redux";
import { ROUTES } from "../../../../hooks/routes/url-constant";
import { clearAdminAccessRoleAndPermissionreducer } from "../../../../hooks/redux/slice/admin-role-permissions";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Container } from "@mui/material";
import { toastEmitter } from "../../../../utils/utilities";
function Topbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    document.querySelector(".side-header-toggle").onclick = function () {
      const element = document.querySelector("#side-bar-show");
      if (element.getAttribute("class") === "sidebar") {
        element.setAttribute("class", "sidebar active_sidebar");
      } else {
        element.setAttribute("class", "sidebar");
      }
    };
    document.querySelector(".ti-close").onclick = function () {
      const element2 = document.querySelector("#side-bar-show");
      if (element2.getAttribute("class") === "sidebar") {
        element2.setAttribute("class", "sidebar active_sidebar");
      } else {
        element2.setAttribute("class", "sidebar");
      }
    };
  }, []);
  const handleLogout = () => {
    toastEmitter("success", " Logout Sucessfully !");
    dispatch(clearAdminAccessTokenReducer())
    dispatch(clearAdminAccessRoleAndPermissionreducer());
    localStorage.removeItem("nMenuData")
    navigate(`${process.env.PUBLIC_URL}/admin/login`)
  }


  const Item = styled(Paper)(({ theme, status }) => ({
    backgroundColor: status === 1 ? '#205da6' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <>
      <div className="container-fluid topSection g-0 px-3 px-md-0">
        <div className="row">
          <div className="col-lg-12 p-0 ">
            <div className="header_iner admin-header_iner d-flex justify-content-end align-items-center">
              <div
                type="button"
                className="sidebar_icon side-header-toggle "
              >
                {/* ti-menu */}
                <i className="d-flex justify-content-center align-items-center">
                  <div className="admin-header ">
                    <img src={PMBI_ADMIN_LOGO} alt="" />
                  </div>
                </i>
              </div>

              <div className="header_right d-flex align-items-center">
                <div className="header_notification_warp d-flex align-items-center">
                  <li className="admin-li-logout ms-3">
                    <div className="bell_notification_clicker profile_info ">
                      <img src={ADMIN_MSG_ICON} width={20} />
                      <div class="profile_info_iner">
                        <div class="profile_info_details">
                          <Link to={ROUTES?.ADMIN.PROFILE_CHANGE}>MY PROFILE </Link>
                          <Link to={ROUTES?.ADMIN.PASSWORD_CHANGE}>CHANGE PASSWORD</Link>
                          <Link className="text-danger" to={`${process.env.PUBLIC_URL}/admin/login`} onClick={handleLogout}>LOG OUT</Link>
                        </div>
                      </div>
                    </div>
                  </li>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Topbar;
